import React from 'react';
import { useNavigate } from 'react-router-dom';

const RightProductSection = ({ products, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
      {products.map((product) => (
        <div 
          key={product._id} 
          className="group cursor-pointer"
          onClick={() => navigate(`/product/${product._id}`)}
        >
          <div className="aspect-square bg-gray-100 mb-3 overflow-hidden">
            <img 
              src={product.image_url} 
              alt={product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/400x400?text=No+Image';
              }}
            />
          </div>
          <div className="space-y-1">
            <p className="text-sm font-medium text-red-600">Just In</p>
            <h3 className="font-medium">{product.name}</h3>
            <p className="text-sm text-gray-600">{product.category}</p>
            <p className="text-sm text-gray-600">1 Colour</p>
            <p className="font-medium mt-2">MRP : ₹ {product.price}</p>
          </div>
        </div>
      ))}

      {!loading && products.length === 0 && (
        <div className="col-span-full text-center py-20">
          <h3 className="text-xl font-medium text-gray-600 mb-2">No products found</h3>
          <p className="text-gray-500">Try adjusting your filters</p>
        </div>
      )}
    </div>
  );
};

export default RightProductSection;
